// extracted by mini-css-extract-plugin
module.exports = {"wvvtqhu":"wvvtqhu","c4b5hm0":"c4b5hm0"};